const ONBOARDING_TOOLTIP_CLASS_NAME = 'onboardingTooltip';

export default ONBOARDING_TOOLTIP_CLASS_NAME;
